export const TILE_ICON_SIZE = 36;

/**
 * Contenedor 64×64 px para iconografía AGDYSA.
 * Fondo suave + icono estándar #3C7C3C; al hover del padre `.group`
 * el tile se rellena con brand-icon y el SVG pasa a blanco.
 */
export function GreenIconTile({ children, className = "", rounded = "rounded-[22px]" }) {
  return (
    <div
      className={[
        "w-16 h-16 shrink-0 flex items-center justify-center",
        "bg-brand-icon/10 shadow-xl shadow-brand-icon/10",
        "transition-all duration-500",
        "group-hover:bg-brand-icon",
        "[&_svg]:text-brand-icon group-hover:[&_svg]:text-white",
        "[&_svg]:overflow-visible",
        rounded,
        className,
      ].join(" ")}
    >
      {children}
    </div>
  );
}
